import { pick } from "lodash";

const getUniqueId = (customer) => {
  return Object.values(customer).reduce((acc, value) => acc + value);
};

const getDuplicateCustomers = (duplicateCustomers, originalCustomerId) => {
  return duplicateCustomers.map((customer) => ({
    ...customer,
    duplicateCustomerId: getUniqueId(customer),
    originalCustomerId,
  }));
};

const getFormattedCustomerData = (customers) => {
  return customers.map((originalCustomer) => {
    return {
      ...originalCustomer,
      duplicateCustomers: getDuplicateCustomers(
        originalCustomer.duplicateCustomers,
        originalCustomer.originalCustomerId
      ),
    };
  });
};

const isAliasesPartiallySelected = (
  totalAliasesSelected,
  totalDuplicateCustomers
) => {
  return (
    totalAliasesSelected > 0 && totalAliasesSelected < totalDuplicateCustomers
  );
};

const getRemoveAliasData = (duplicateCustomers, selectedCustomers) => {
  return duplicateCustomers
    .filter((customer) =>
      selectedCustomers.includes(customer.duplicateCustomerId)
    )
    .map((customer) =>
      pick(customer, [
        "duplicateCustomerCode",
        "duplicateCustomerName",
        "duplicateCustomerAddress",
        "duplicateCustomerCity",
        "duplicateCustomerState",
        "duplicateCustomerZip",
        "originalCustomerId",
      ])
    );
};

export {
  getFormattedCustomerData,
  isAliasesPartiallySelected,
  getRemoveAliasData,
};
